<template>
  <div>
    <v-row justify="center">
      <v-dialog
        v-model="inputedValue"
        scrollable
        :width="width"
        :persistent="persistent"
      >
        <v-card class="rounded-lg">
          <v-card-text class="cardTextStyle pa-1">
            <slot />
          </v-card-text>

          <v-card-actions v-if="isFooter">
            <slot name="footer" />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    value: { default: false },
    width: { default: '540px' },
    isFooter: { default: false },
    persistent: { default: false }
  },
  data: () => ({
    displayFlg: false
  }),
  methods: {
    close() {
      this.inputedValue = false
    },
    complete() {
      this.inputedValue = false
    }
  },
  computed: {
    inputedValue: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cardTextStyle {
  // background-color: #f6f6f6;
  font-size: 14px;
  color: #000 !important;
}
.cardBackgroundStyle {
  background-color: #f6f6f6;
  // font-size: 14px;
}

.isPaddingNormal {
  padding: 10px !important;
}
.cardActionsStyle {
  background-color: #f9fbfe;
}
.dialogTitleStyle {
  font-size: 22px;
}
.border {
  border: 1px solid #d8d8d8 !important;
}
</style>
